import Vue from 'vue'
import VueRouter from 'vue-router'
import { MessageBox } from 'element-ui'
import $store from '@/store/index.js' //使用Vuex

Vue.use(VueRouter)
// 首页
import home from '../views/home.vue'
import institutionalOverview from '../views/institutional-overview/index.vue'
import partyBuilding from '../views/party-building/index.vue'
import specialColumn from '../views/special-column/index.vue'
import report from '../views/report/index.vue'
import officeHall from '../views/office-hall/index.vue'
import document from '../views/document/index.vue'
import details from '../views/document/details.vue'
import leaderDetails from '../views/document/leader-details.vue'

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const routes = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: home,
  },
  {
    path: '/home',
    name: 'home-page',
    component: home,
  },
  // 机构概况
  {
    path: '/institutional-overview',
    name: 'institutionalOverview',
    component: institutionalOverview,
  },
  // 器检党建
  {
    path: '/party-building',
    name: 'partyBuilding',
    component: partyBuilding,
  },

  // 公众服务
  {
    path: '/office-hall',
    name: 'officeHall',
    component: officeHall,
  },
  // 通用文章
  {
    path: '/document',
    name: 'document',
    component: document,
  },
  // 通用文章详情
  {
    path: '/details',
    name: 'details',
    component: details,
  },
  // 机构领导详情
  {
    path: '/leader-details',
    name: 'leaderDetails',
    component: leaderDetails,
  },
  // 专题专栏
  {
    path: '/special-column',
    name: 'specialColumn',
    component: specialColumn,
  },
  // 纪检举报方式
  {
    path: '/report',
    name: 'report',
    component: report,
  },
]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  keepAlive: true,
  routes,
  base: process.env.VUE_APP_CONTEXT,
  // 路由跳转始终回到顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  next() //放行
})

export default router
